






































































































import {
  Component, Mixins, Prop,
} from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import { TemplateType } from '@/store/templates/types';
import UserMixin from '@/mixins/UserMixin';
import { cloneDeep } from 'lodash';

@Component
export default class ApplicationHRForm extends Mixins(UserMixin) {
  @Action('fetchTemplates', { namespace: 'templates' })
  fetchTemplates: any;

  @Action('createTemplate', { namespace: 'templates' })
  createTemplate: any;

  @Action('updateTemplate', { namespace: 'templates' })
  updateTemplate: any;

  @Action('deleteTemplate', { namespace: 'templates' })
  deleteTemplate: any;

  @Action('setTemplatesIsLoading', { namespace: 'templates' })
  setTemplatesIsLoading: any;

  @State('templates', { namespace: 'templates' })
  readonly templates!: TemplateType[];

  @State('templatesIsLoading', { namespace: 'templates' })
  readonly templatesIsLoading!: boolean;

  @Prop({
    type: Object,
  }) readonly formData!: any

  sheetTemplates = false;

  nameNewTemplate = '';

  selectedUseTemplate = '';

  selectedUpdateTemplate = '';

  selectedDeleteTemplate = '';

  get validationsNewName() {
    return this.templates.some((i) => i.name === this.nameNewTemplate);
  }

  async createTemplateAndFetchTemplates() {
    this.setTemplatesIsLoading(true);
    await this.createTemplate({
      name: this.nameNewTemplate,
      userId: this.pimcoreUser?.id,
      data: this.formData,
    });
    this.clear();
    await this.fetchTemplates({ userId: this.pimcoreUser?.id });
  }

  async updateTemplateAndFetchTemplates() {
    this.setTemplatesIsLoading(true);
    await this.updateTemplate({
      templateId: this.selectedUpdateTemplate,
      data: this.formData,
    });
    this.clear();
    await this.fetchTemplates({ userId: this.pimcoreUser?.id });
  }

  async deleteTemplateAndFetchTemplates() {
    this.setTemplatesIsLoading(true);
    await this.deleteTemplate(this.selectedDeleteTemplate);
    this.clear();
    await this.fetchTemplates({ userId: this.pimcoreUser?.id });
  }

  async beforeMount() {
    if (!this.isSupplier && this.pimcoreUser?.id) {
      this.fetchTemplates({ userId: this.pimcoreUser?.id });
    }
  }

  getValidationErrors(): string[] {
    const errors: string[] = [];
    if (this.validationsNewName) {
      errors.push('Имя уже существует');
    }
    return errors;
  }

  useTemplate(id: string) {
    const template = this.templates.find((i) => Number(i.id) === Number(id));
    if (template) {
      this.$emit('useTemplate', cloneDeep(template));
      this.$nextTick(() => {
        this.selectedUseTemplate = '';
      });
    }
  }

  clear() {
    this.nameNewTemplate = '';
    this.selectedUpdateTemplate = '';
    this.selectedDeleteTemplate = '';
  }
}
